import { Container, styled, Typography } from "@mui/material";
import DataGridTemplates from "../../components/organismos/plantillas/DataGridTemplates";
import { useLoaderTemplates } from "../../hooks/templates/useLoaderTemplates";
import { useEffect } from "react";
import TemplateActionsController from "../../components/moleculas/templates/ActionsController";
import TemplateFilterController from "../../components/moleculas/templates/FilterController";
import { useRoleCheck } from "../../hooks/useRoleCheck";

const Titled = styled(Typography)(() => ({
  textTransform: "capitalize",
}));

const Templates = () => {
  const { loadTemplates, paginated } = useLoaderTemplates();
  const canAccess = useRoleCheck(["superadmin", "admin"]);

  useEffect(() => {
    loadTemplates();
  }, [paginated]);

  if (!canAccess) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Acceso denegado
      </Typography>
    );
  }

  return (
    <Container>
      <Titled variant="h3">Plantillas</Titled>
      <TemplateFilterController />
      <TemplateActionsController />
      <DataGridTemplates />
    </Container>
  );
};

export default Templates;
